module.exports = __webpack_public_path__ + "img/weather-cloud.0791ccd1.png";